import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {GestioneListinoComponent} from './gestione-listino';
import {CreaProfiloModule} from './crea-profilo/crea-profilo.module';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

  $stateProvider
    .state('home.gestione-listino', {
      url: '/gestione-listino/:limit',
      ncyBreadcrumb: {
        label: 'gestione-listino',
        parent: 'home.gestione-profili'
      },
      params: {
        limit: ''
      },
      data: {
        authorisationLevel: 2,
        pageTitle: 'gestione-listino'
      },
      'views': {
        'homeContent': {
          template: '<gestione-listino flex="100"></gestione-listino>'
        }
      }
    });
};

stateConfig.$inject = ['$stateProvider'];

export const GestioneListinoModule: string = ng
  .module('gestione-listino', [
    'ui.bootstrap',
    uiRouter,
    CreaProfiloModule
  ])
  .component('gestioneListino', GestioneListinoComponent)
  .config(stateConfig)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/gestione-profili/gestione-listino/gestione-listino.module.ts